<template>
	
	<div class="referral__sub-heading mb-5">How it Works:</div>



	<div class="referral__steps-container">
		<ReferralStepsTile v-for="(tile, index) in tiles" :key="index" class="referral__steps-tile mt-5">

			<template v-slot:step> {{ tile.step }} </template>
		
			<template v-slot:icon>
				<component :is="tile.icon" />
			</template>

			<template v-slot:title> {{ tile.title }} </template>
		
			<template v-slot:subtitle> {{ tile.subtitle }} </template>

		</ReferralStepsTile>
	</div>



</template>



<script setup>

import { ref, markRaw } from 'vue';
import InviteFriends from '@/icons/Referral/InviteFriends.vue';
import InstallApp from '@/icons/Referral/InstallApp.vue';
import GetReward from '@/icons/Referral/GetReward.vue';
import ReferralStepsTile from '@/components/Tiles/Referral/Referral-Steps-Tile.vue';

const tiles = ref([
    {
        title: 'Invite Your Friends',
        subtitle: 'Invite your friends & family and share your referral code.',
        step: 1,
        icon: markRaw(InviteFriends),
    },
    {
        title: 'Install app with referral',
        subtitle: 'Friends & family install the app & enter your referral code.',
        step: 2,
        icon: markRaw(InstallApp),
    },
    {
        title: 'Get Rewarded!',
        subtitle: 'After installation You & your friends & family get rewarded!',
        step: 3,
        icon: markRaw(GetReward),
    }
]);

</script>